import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPatch, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { UpdateUserDto, UserDetail } from '@/types/settings';

export const useUpdateUser = createMutationHook<UserDetail, { userId: string } & UpdateUserDto>({
  mutationFn: ({ userId, ...dto }) =>
    apiPatch<UserDetail, UpdateUserDto>(
      operationsClient,
      settingsEndpoints.updateUser(userId),
      dto,
    ),
  onSuccess: (_data, { userId }, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.users() });
    void queryClient.invalidateQueries({ queryKey: settingsKeys.userDetail(userId) });
    toast.success('User updated');
  },
});
